export const types = {
    CHANGE_MAIN_AUDIO_CATEGORY_INDEX: 'change_main_audio_category_index',
    CHANGE_SECOND_AUDIO_CATEGORY_INDEX: 'change_second_audio_category_index',
    ADD_SOUND_CLIPART_MODEL: 'add_sound_clipart_model',
    CHANGE_MUSIC_CONTENT_INDEX: 'change_music_content_index',
    CHANGE_SLIDE_AUDIO_INDEX: 'change_slide_audio_index',
    CHANGE_SOUND_EFFECTS_CATEGORY_INDEX: 'change_sound_effects_category_index'
};

export function changeMainAudioCategoryIndex(index) {
    return { type: types.CHANGE_MAIN_AUDIO_CATEGORY_INDEX, index};
}

export function changeSoundEffectsCategoryIndex(index) {
    return { type: types.CHANGE_SOUND_EFFECTS_CATEGORY_INDEX, index};
}

export function changeSecondAudioCategoryIndex(index) {
    return { type: types.CHANGE_SECOND_AUDIO_CATEGORY_INDEX, index};
}

export function addSoundClipartModel(clipartModel) {
    return { type: types.ADD_SOUND_CLIPART_MODEL, clipartModel};
}

export function changeMusicContentIndex(index) {
    return { type: types.CHANGE_MUSIC_CONTENT_INDEX, index};
}

export function changeSlideAudioIndex(index) {
    return { type: types.CHANGE_SLIDE_AUDIO_INDEX, index};
}



/** WEBPACK FOOTER **
 ** ./src/actions/MusicActions.js
 **/